module.exports = __webpack_public_path__ + "img/MorningMeltdown100.40b7e196.jpeg";